<template>
  <div>
    <LazyAutocomplete
      :value="value"
      :label="label"
      :items.sync="localItems"
      :placeholder="placeholder"
      :total-items="totalItems"
      :color-fn="colorFn"
      no-filter
      dense
      outlined
      append-icon="search"
      :multiple-select="multipleSelect"
      :disabled="disabled"
      :hide-details="hideDetails"
      :error-messages="errorMessages"
      :data-test="dataTest"
      @input="$emit('input', $event)"
      @getItems="$emit(`getItems`, $event)"
      @update:items="$emit('update:items', localItems)"
      @click-append="id && (openModal = true)"
    />

    <ModalWindow
      :id="id"
      v-model="openModal"
      :component-name="componentName"
      @close="openModal = false"
    />
  </div>
</template>

<script>
export default {
  components: {
    ModalWindow() {
      return import("@/components/ModalWindow.vue");
    },
  },
  props: {
    id: {
      type: [String, Number],
      default: 0,
    },
    value: {
      type: [Object, Array],
    },
    label: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => [],
    },
    totalItems: {
      type: Number,
      default: 0,
    },
    componentName: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: Boolean,
      default: true,
    },
    errorMessages: {
      type: Array,
    },
    colorFn: {
      type: Function,
      default: () => "",
    },
    multipleSelect: {
      type: Boolean,
      default: false,
    },
    dataTest: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    openModal: false,
    localItems: [],
  }),
  watch: {
    items(val) {
      this.localItems = val;
    },
  },
};
</script>
